export const Locations = {
    PRAGUE: { lat: 50.096083, lng: 14.4548891 },
    BERLIN: { lat: 52.453218, lng: 13.385149 },
};

export const Links = {
    PRAGUE: 'https://goo.gl/maps/ya9tdeQGA8TJphK57',
    BERLIN: 'https://goo.gl/maps/UQS8CdZ3GA7vuFcB9',
};
